export default __webpack_public_path__ + "static/media/map.bc6854bb.png";